/**
 * Created by ianva on 16/4/13.
 */

var domain = '//www.xcds.com.cn';

module.exports = {
    walleEdit : {
        url: domain + '/trip/walle/'
    }
}


/** WEBPACK FOOTER **
 ** ./script/conf/walle-target.js
 **/